/* ======================================================
   STORAGE
====================================================== */
const STORAGE_KEY = "skinify_state";

/* ======================================================
   STATE
====================================================== */
let state = {
  step: 0,
  gender: null,
  skinType: null,
  concern: null,
  vibe: null,
  solutionTabIndex: 0,
  selectedProducts: {}

};

let activeTab = null;

/* ======================================================
   LOAD / SAVE
====================================================== */
function loadState() {
  const s = localStorage.getItem(STORAGE_KEY);
  if (s) state = JSON.parse(s);
}
function saveState() {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

/* ======================================================
   QUIZ STEPS
====================================================== */
const steps = [
  {
    key: "age",
    title: "Select your age",
    subtitle: "Please select any one",
    options: ["13-19", "20-30", "31-40", "40+"]
  },
  {
    key: "gender",
    title: "Tell us a little about yourself",
    subtitle: "Please select any one",
    options: ["Him", "Her", "Prefer not to say"]
  },
  {
    key: "skinType",
    title: "Select Skin Type",
    subtitle: "Please select any one",
    options: [
      "Normal",
      "Dry",
      "Oily",
      "Sensitive",
      "Combination",
      "Not sure"
    ]
  },
  {
    key: "concern",
    title: "Select your Main Concern",
    subtitle: "Please select any one",
    options: [
      "Dryness / Rough patches",
      "Pigmentation / Uneven tone",
      "Body acne / Bumps",
      "Strawberry skin (KP)/ Ingrown Hair",
      "Dullness",
      "Tanning",
      "Sore Muscle/relaxation"
    ]
  },
  {
    key: "vibe",
    title: "Select the Vibes that feels right",
    subtitle: "Please select any one",
    options: [
      "Date Mode",
      "Office Ready",
      "Party Night",
      "Chill Day Out",
      "Self-care Day",
      "Outdoor Day"
    ]
  }
];

/* ======================================================
   optionIconMap icon mapping for better UX in options
====================================================== */
const optionIconMap = {
   age: {
    "13-19": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/user.svg' width='100%' height='auto' alt='Him'/>",
    "20-30": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/user.svg' width='100%' height='auto' alt='Her'/>",
    "31-40": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/user.svg' width='100%' height='auto' alt='Unisex'/>",
    "40+": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/user.svg' width='100%' height='auto' alt='Unisex'/>"
  },
  gender: {
    Him: "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/Him.svg?v=1770987381' width='100%' height='auto' alt='Him'/>",
    Her: "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/Her.svg?v=1770987380' width='100%' height='auto' alt='Her'/>",
    "Prefer not to say" : "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/Unisex.svg?v=1770987379' width='100%' height='auto' alt='Unisex'/>"
  },
  skinType: {
    "Normal": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/balanced_skin.svg' width='100%' height='auto' alt='Normal'/>",
    "Dry": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/dryyy.svg' width='100%' height='auto' alt='Dry'/>",
    "Oily": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/oily_b52493aa-e02b-4645-a2c8-b0293df7c50d.svg' width='100%' height='auto' alt='Oily'/>",
    "Sensitive": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/sensitive_skin.svg' width='100%' height='auto' alt='Sensitive'/>",
    "Combination": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/combination2.svg' width='100%' height='auto' alt='Combination'/>",
    "Not sure": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/not_sure_99a638d1-698c-44b9-ab89-78cf9cbbd012.svg' width='100%' height='auto' alt='Not Sure'/>"
  },
  concern: {
    "Dryness / Rough patches": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/DRY_f7d2c52e-6449-4273-b0d5-f83709974c81.svg' width='100%' height='auto' alt='Normal'/>",
    "Pigmentation / Uneven tone": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/pigmentationn.svg' width='100%' height='auto' alt='Pigmentation'/>",
    "Body acne / Bumps": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/acneee.svg' width='100%' height='auto' alt='Acne'/>",
    "Strawberry skin (KP)/ Ingrown Hair": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/INGROWNHAIR.svg' width='100%' height='auto' alt='KP'/>",
    "Dullness": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/dull_skinnn.svg' width='100%' height='auto' alt='Dullness'/>",
    "Tanning": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/TAN.svg' width='100%' height='auto' alt='Tanning'/>",
    "Sore Muscle/relaxation": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/sore_muscles_ac804dc7-782e-4ce3-87c4-95d4bbacb0c4.svg' width='100%' height='auto' alt='Muscle Relaxation'/>"
  },
  vibe: {
    "Date Mode": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/DATEE.svg' width='100%' height='auto' alt='Date Mode'/>",
    "Office Ready": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/WORK.svg' width='100%' height='auto' alt='Office Ready'/>",
    "Party Night": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/partyy.svg' width='100%' height='auto' alt='Party Night'/>",
    "Chill Day Out": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/CHILL_0e27b1d0-f6c2-4c19-92ce-febead1ff6ca.svg' width='100%' height='auto' alt='Chill Day Out'/>",
    "Self-care Day": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/SELFCARE.svg' width='100%' height='auto' alt='Self Care Day'/>",
    "Outdoor Day": "<img src='https://cdn.shopify.com/s/files/1/1454/5188/files/OUTDOOR2.svg' width='100%' height='auto' alt='Outdoor Day'/>"
  }
};

/* ======================================================
   VIBE COPY
====================================================== */
const vibeCopy = {
  "Date Mode": "Get Ready for Date Night",
  "Office Ready": "Stay Fresh for Work",
  "Party Night": "Glow for the Night",
  "Chill Day Out": "Relax & Recharge",
  "Self-care Day": "Time for Self Care",
  "Outdoor Day": "Stay Fresh Outdoors"
};

/* ======================================================
   PRODUCT MAPPING
   (USE YOUR FULL MAPPING HERE — SAME AS YOU SHARED)
====================================================== */


const routineMapping = {

  /* ======================================================
     🔒 DRYNESS / ROUGH PATCHES
  ====================================================== */
  "Dryness / Rough patches": {

    Him: {
      "Body Wash": {
        title: "Blueberry Body Wash",
        handle: "blueberry-blast-body-wash",
        benefits: [
          "Makes Skin Soft",
          "Hydrates Skin",
          "Fruity Blueberry Aroma"
        ],
        ingredients: "Hyaluronic Acid | Blueberry Extracts"
      },
      "Body Scrub": {
        title: "Blueberry Body Scrub",
        handle: "blueberry-body-scrub",
        benefits: [
          "Smoothens Skin",
          "Nourishes Skin",
          "Refreshing Blueberry Aroma"
        ],
        ingredients: "Blueberry Extracts | Coffee"
      },
      "Body Lotion": {
        title: "Summer Breeze Body Lotion",
        handle: "summer-breeze-perfume-body-lotion",
        benefits: [
          "Moisturizes deeply",
          "Helps even skin tone",
          "Aqua fresh fragrance"
        ],
        ingredients: "Niacinamide | Cocoa Butter | Caffeine"
      }
    },

    Her: {
      "Body Wash": {
        title: "Blueberry Body Wash",
        handle: "blueberry-blast-body-wash",
        benefits: [
          "Makes Skin Soft",
          "Hydrates Skin",
          "Fruity Blueberry Aroma"
        ],
        ingredients: "Hyaluronic Acid | Blueberry Extracts"
      },
      "Body Scrub": {
        title: "Blueberry Body Scrub",
        handle: "blueberry-body-scrub",
        benefits: [
          "Smoothens Skin",
          "Nourishes Skin",
          "Refreshing Blueberry Aroma"
        ],
        ingredients: "Blueberry Extracts | Coffee"
      },
      "Body Lotion": {
        title: "Sweet Escape Body Lotion",
        handle: "sweet-escape-perfume-body-lotion",
        benefits: [
          "Moisturizes deeply",
          "Evens skin tone",
          "Fruity floral fragrance"
        ],
        ingredients: "Niacinamide | Cocoa Butter | Caffeine"
      }
    },

    Unisex: {
      "Body Wash": {
        title: "Blueberry Body Wash",
        handle: "blueberry-blast-body-wash",
        benefits: [
          "Makes Skin Soft",
          "Hydrates Skin",
          "Fruity Blueberry Aroma"
        ],
        ingredients: "Hyaluronic Acid | Blueberry Extracts"
      },
      "Body Scrub": {
        title: "Blueberry Body Scrub",
        handle: "blueberry-body-scrub",
        benefits: [
          "Smoothens Skin",
          "Nourishes Skin",
          "Refreshing Blueberry Aroma"
        ],
        ingredients: "Blueberry Extracts | Coffee"
      },
      "Body Lotion": {
        title: "Choco Body Butter",
        handle: "naked-and-rich-choco-body-butter-with-caramel",
        benefits: [
          "Heals dry, flaky skin",
          "Intensely moisturizes",
          "Indulgent chocolatey aroma"
        ],
        ingredients: "Cocoa Butter | Shea Butter | Caffeine"
      }
    }
  },

  /* ======================================================
     ✨ PIGMENTATION / UNEVEN TONE
  ====================================================== */
  "Pigmentation / Uneven tone": {

    Him: {
      "Body Wash": {
        title: "Guava Tini Body Wash",
        handle: "guava-tini-de-tan-body-wash",
        benefits: [
          "Reduces Dark Spots",
          "Evens Skin Tone",
          "Brightens Skin",
          "Juicy Guava Fragrance"
        ],
        ingredients: "Glycolic Acid | Niacinamide | Glutathione"
      },
      "Body Scrub": {
        title: "Raspberry Body Scrub",
        handle: "brightening-raspberry-rush-body-scrub",
        benefits: [
          "Brightens Skin",
          "Exfoliates Skin",
          "Fruity Raspberry Aroma"
        ],
        ingredients: "Blend of AHAs – Lactic & Glycolic Acid | Niacinamide"
      },
      "Body Lotion": {
        title: "By The Blues Body Lotion",
        handle: "by-the-blues-brightening-perfume-body-lotion-300ml",
        benefits: [
          "Helps even skin tone",
          "Brightens skin",
          "Aqua woody scent"
        ],
        ingredients: "Niacinamide | Glutathione"
      }
    },

    Her: {
      "Body Wash": {
        title: "Guava Tini Body Wash",
        handle: "guava-tini-de-tan-body-wash",
        benefits: [
          "Reduces Dark Spots",
          "Evens Skin Tone",
          "Brightens Skin",
          "Juicy Guava Fragrance"
        ],
        ingredients: "Glycolic Acid | Niacinamide | Glutathione"
      },
      "Body Scrub": {
        title: "Raspberry Body Scrub",
        handle: "brightening-raspberry-rush-body-scrub",
        benefits: [
          "Brightens Skin",
          "Exfoliates Skin",
          "Fruity Raspberry Aroma"
        ],
        ingredients: "Blend of AHAs – Lactic & Glycolic Acid | Niacinamide"
      },
      "Body Lotion": {
        title: "By The Blues Body Lotion",
        handle: "by-the-blues-brightening-perfume-body-lotion-300ml",
        benefits: [
          "Helps even skin tone",
          "Brightens skin",
          "Aqua woody scent"
        ],
        ingredients: "Niacinamide | Glutathione"
      }
    },

    Unisex: {
      "Body Wash": {
        title: "Guava Tini Body Wash",
        handle: "guava-tini-de-tan-body-wash",
        benefits: [
          "Reduces Dark Spots",
          "Evens Skin Tone",
          "Brightens Skin",
          "Juicy Guava Fragrance"
        ],
        ingredients: "Glycolic Acid | Niacinamide | Glutathione"
      },
      "Body Scrub": {
        title: "Raspberry Body Scrub",
        handle: "brightening-raspberry-rush-body-scrub",
        benefits: [
          "Brightens Skin",
          "Exfoliates Skin",
          "Fruity Raspberry Aroma"
        ],
        ingredients: "Blend of AHAs – Lactic & Glycolic Acid | Niacinamide"
      },
      "Body Lotion": {
        title: "By The Blues Body Lotion",
        handle: "by-the-blues-brightening-perfume-body-lotion-300ml",
        benefits: [
          "Helps even skin tone",
          "Brightens skin",
          "Aqua woody scent"
        ],
        ingredients: "Niacinamide | Glutathione"
      }
    }
  },

  /* ======================================================
     🚫 BODY ACNE / BUMPS
  ====================================================== */
  "Body acne / Bumps": {

    Him: {
      "Body Wash": {
        title: "Caramel Crunch Body Wash",
        handle: "exfoliating-caramel-crunch-body-wash",
        benefits: [
          "Reduces Body Acne",
          "Reduces Strawberry Skin",
          "Helps Exfoliate Dead Skin"
        ],
        ingredients: "Salicylic Acid | Lactic Acid | Willow Bark"
      },
      "Body Scrub": {
        title: "Blueberry Body Scrub",
        handle: "blueberry-body-scrub",
        benefits: [
          "Smoothens Skin",
          "Nourishes Skin"
        ],
        ingredients: "Blueberry Extracts | Coffee",
        note: "*Not Recommended for Highly sensitive skin"
      },
      "Body Lotion": {
        title: "Raspberry Body Lotion with SPF",
        handle: "brightening-raspberry-spf-50-pa-body-sunscreen-lotion",
        benefits: [
          "Reduces Tan",
          "Cools skin instantly",
          "Provides sun protection"
        ],
        ingredients: "Raspberry Extract, Niacinamide, Coffee Extract"
      }
    },

    Her: {
      "Body Wash": {
        title: "Caramel Crunch Body Wash",
        handle: "exfoliating-caramel-crunch-body-wash",
        benefits: [
          "Reduces Body Acne",
          "Reduces Strawberry Skin",
          "Helps Exfoliate Dead Skin"
        ],
        ingredients: "Salicylic Acid | Lactic Acid | Willow Bark"
      },
      "Body Scrub": {
        title: "Raspberry Body Scrub",
        handle: "brightening-raspberry-rush-body-scrub",
        benefits: [
          "Smoothens Skin",
          "Nourishes Skin"
        ],
        ingredients: "Blend of AHAs – Lactic & Glycolic Acid | Niacinamide",
        note: "*Not Recommended for Highly sensitive skin"
      },
      "Body Lotion": {
        title: "Raspberry Body Lotion with SPF",
        handle: "brightening-raspberry-spf-50-pa-body-sunscreen-lotion",
        benefits: [
          "Reduces Tan",
          "Cools skin instantly",
          "Provides sun protection"
        ],
        ingredients: "Raspberry Extract | Niacinamide | Coffee Extract"
      }
    },

    Unisex: {
      "Body Wash": {
        title: "Caramel Crunch Body Wash",
        handle: "exfoliating-caramel-crunch-body-wash",
        benefits: [
          "Reduces Body Acne",
          "Reduces Strawberry Skin",
          "Helps Exfoliate Dead Skin"
        ],
        ingredients: "Salicylic Acid | Lactic Acid | Willow Bark"
      },
      "Body Scrub": {
        title: "Raspberry Body Scrub",
        handle: "brightening-raspberry-rush-body-scrub",
        benefits: [
          "Smoothens Skin",
          "Nourishes Skin"
        ],
        ingredients: "Blend of AHAs – Lactic & Glycolic Acid | Niacinamide",
        note: "*Not Recommended for Highly sensitive skin"
      },
      "Body Lotion": {
        title: "Raspberry Body Lotion with SPF",
        handle: "brightening-raspberry-spf-50-pa-body-sunscreen-lotion",
        benefits: [
          "Reduces Tan",
          "Cools skin instantly",
          "Provides sun protection"
        ],
        ingredients: "Raspberry Extract | Niacinamide | Coffee Extract"
      }
    }
  },

  /* ======================================================
     Strawberry skin (KP)/ Ingrown Hair
  ====================================================== */
  "Strawberry skin (KP)/ Ingrown Hair": {

    Him: {
      "Body Wash": {
        title: "Caramel Crunch Body Wash",
        handle: "exfoliating-caramel-crunch-body-wash",
        benefits: [
          "Reduces Body Acne",
          "Reduces Strawberry Skin",
          "Helps Exfoliate Dead Skin"
        ],
        ingredients: "Salicylic Acid | Lactic Acid | Willow Bark"
      },
      "Body Scrub": {
        title: "Coffee Body Scrub",
        handle: "naked-raw-coffee-body-scrub-with-coconut",
        benefits: [
          "Removes Dead Skin",
          "Energizing Coffee Aroma"
        ],
        ingredients: "Coffee | Caffeine"
      },
      "Body Lotion": {
        title: "11% AHA BHA Strawberry Body Lotion",
        handle: "11-aha-bha-strawberry-body-lotion-for-skin-smoothening",
        benefits: [
          "Exfoliates dead skin",
          "Helps reduce bumpy & strawberry skin",
          "Moisturizes deeply"
        ],
        ingredients: "Glycolic Acid | Lactic Acid | Salicylic Acid"
      }
    },

    Her: {
      "Body Wash": {
        title: "Caramel Crunch Body Wash",
        handle: "exfoliating-caramel-crunch-body-wash",
        benefits: [
          "Reduces Body Acne",
          "Reduces Strawberry Skin",
          "Helps Exfoliate Dead Skin"
        ],
        ingredients: "Salicylic Acid | Lactic Acid | Willow Bark"
      },
      "Body Scrub": {
        title: "Coffee Body Scrub",
        handle: "naked-raw-coffee-body-scrub-with-coconut",
        benefits: [
          "Removes Dead Skin",
          "Energizing Coffee Aroma"
        ],
        ingredients: "Coffee | Caffeine"
      },
      "Body Lotion": {
        title: "11% AHA BHA Strawberry Body Lotion",
        handle: "11-aha-bha-strawberry-body-lotion-for-skin-smoothening",
        benefits: [
          "Exfoliates dead skin",
          "Helps reduce bumpy & strawberry skin",
          "Moisturizes deeply"
        ],
        ingredients: "Glycolic Acid | Lactic Acid | Salicylic Acid"
      }
    },

    Unisex: {
      "Body Wash": {
        title: "Caramel Crunch Body Wash",
        handle: "exfoliating-caramel-crunch-body-wash",
        benefits: [
          "Reduces Body Acne",
          "Reduces Strawberry Skin",
          "Helps Exfoliate Dead Skin"
        ],
        ingredients: "Salicylic Acid | Lactic Acid | Willow Bark"
      },
      "Body Scrub": {
        title: "Coffee Body Scrub",
        handle: "naked-raw-coffee-body-scrub-with-coconut",
        benefits: [
          "Removes Dead Skin",
          "Energizing Coffee Aroma"
        ],
        ingredients: "Coffee | Caffeine"
      },
      "Body Lotion": {
        title: "11% AHA BHA Strawberry Body Lotion",
        handle: "11-aha-bha-strawberry-body-lotion-for-skin-smoothening",
        benefits: [
          "Exfoliates dead skin",
          "Helps reduce bumpy & strawberry skin",
          "Moisturizes deeply"
        ],
        ingredients: "Glycolic Acid | Lactic Acid | Salicylic Acid"
      }
    }
  },
  /* ======================================================
       Dullness
    ====================================================== */
  "Dullness": {

    Him: {
      "Body Wash": {
        title: "Raspberry Body Wash",
        handle: "brightening-raspberry-rush-body-wash",
        benefits: [
          "Brightens Skin",
          "Makes Skin Soft",
          "Boosts Glow",
          "Fruity Raspberry Fragrance"
        ],
        ingredients: "Niacinamide | Raspberry Extracts"
      },
      "Body Scrub": {
        title: "Raspberry Body Scrub",
        handle: "brightening-raspberry-rush-body-scrub",
        benefits: [
          "Reduces Tan",
          "Smoothens Skin",
          "Nourishes Skin"
        ],
        ingredients: "Blend of AHAs – Lactic & Glycolic Acid | Niacinamide"
      },
      "Body Lotion": {
        title: "By The Blues Body Lotion",
        handle: "by-the-blues-brightening-perfume-body-lotion-300ml",
        benefits: [
          "Helps even skin tone",
          "Brightens skin",
          "Aqua woody scent"
        ],
        ingredients: "Niacinamide | Glutathione"
      }
    },

    Her: { /* identical to Him */
      "Body Wash": {
        title: "Raspberry Body Wash",
        handle: "brightening-raspberry-rush-body-wash",
        benefits: ["Brightens Skin", "Makes Skin Soft", "Boosts Glow", "Fruity Raspberry Fragrance"],
        ingredients: "Niacinamide | Raspberry Extracts"
      },
      "Body Scrub": {
        title: "Raspberry Body Scrub", handle: "brightening-raspberry-rush-body-scrub",
        benefits: ["Reduces Tan", "Smoothens Skin", "Nourishes Skin"],
        ingredients: "Blend of AHAs – Lactic & Glycolic Acid | Niacinamide"
      },
      "Body Lotion": {
        title: "By The Blues Body Lotion",
        handle: "by-the-blues-brightening-perfume-body-lotion-300ml",
        benefits: ["Helps even skin tone", "Brightens skin", "Aqua woody scent"],
        ingredients: "Niacinamide | Glutathione"
      }
    },

    Unisex: { /* identical to Him */
      "Body Wash": {
        title: "Raspberry Body Wash",
        handle: "brightening-raspberry-rush-body-wash",
        benefits: ["Brightens Skin", "Makes Skin Soft", "Boosts Glow", "Fruity Raspberry Fragrance"],
        ingredients: "Niacinamide | Raspberry Extracts"
      },
      "Body Scrub": {
        title: "Raspberry Body Scrub",
        handle: "brightening-raspberry-rush-body-scrub",
        benefits: ["Reduces Tan", "Smoothens Skin", "Nourishes Skin"],
        ingredients: "Blend of AHAs – Lactic & Glycolic Acid | Niacinamide"
      },
      "Body Lotion": {
        title: "By The Blues Body Lotion",
        handle: "by-the-blues-brightening-perfume-body-lotion-300ml",
        benefits: ["Helps even skin tone", "Brightens skin", "Aqua woody scent"],
        ingredients: "Niacinamide | Glutathione"
      }
    }
  },

  /* ======================================================
       Sore Muscle/relaxation
    ====================================================== */

  "Sore Muscle/relaxation": {

    Him: {
      "Body Wash": {
        title: "Blueberry Body Wash",
        handle: "blueberry-blast-body-wash",
        benefits: [
          "Makes Skin Soft",
          "Hydrates Skin",
          "Fruity Blueberry Aroma"
        ],
        ingredients: "Hyaluronic Acid | Blueberry Extracts"
      },
      "Body Scrub": {
        title: "Coffee Body Scrub",
        handle: "naked-raw-coffee-body-scrub-with-coconut",
        benefits: [
          "Reduces Tan",
          "Removes Dead Skin",
          "Energizing Coffee Aroma"
        ],
        ingredients: "Coffee | Caffeine",
        note: "*Not Recommended for Highly sensitive skin"
      },
      "Body Lotion": {
        title: "10% Magnesium Body Lotion",
        handle: "10-magnesium-body-lotion",
        benefits: [
          "Eases muscle cramps",
          "Helps in muscle recovery",
          "Helps promote better sleep",
          "Soothing Vanilla-Orchid Scent"
        ],
        ingredients: "Magnesium, Cocoa Butter, Chamomile"
      }
    },

    Her: {
      "Body Wash": {
        title: "Blueberry Body Wash",
        handle: "blueberry-blast-body-wash",
        benefits: [
          "Makes Skin Soft",
          "Hydrates Skin",
          "Fruity Blueberry Aroma"
        ],
        ingredients: "Hyaluronic Acid | Blueberry Extracts"
      },
      "Body Scrub": {
        title: "Raspberry Body Scrub",
        handle: "brightening-raspberry-rush-body-scrub",
        benefits: [
          "Reduces Tan",
          "Smoothens Skin",
          "Nourishes Skin",
          "Refreshing Blueberry Aroma"
        ],
        ingredients: "Blend of AHAs – Niacinamide, Lactic & Glycolic Acid",
        note: "*Not Recommended for Highly sensitive skin"
      },
      "Body Lotion": {
        title: "10% Magnesium Body Lotion",
        handle: "10-magnesium-body-lotion",
        benefits: [
          "Eases muscle cramps",
          "Helps in muscle recovery",
          "Helps promote better sleep",
          "Soothing Vanilla-Orchid Scent"
        ],
        ingredients: "Magnesium, Cocoa Butter, Chamomile"
      }
    },

    Unisex: {
      "Body Wash": {
        title: "Blueberry Body Wash",
        handle: "blueberry-blast-body-wash",
        benefits: [
          "Makes Skin Soft",
          "Hydrates Skin",
          "Fruity Blueberry Aroma"
        ],
        ingredients: "Hyaluronic Acid | Blueberry Extracts"
      },
      "Body Scrub": {
        title: "Coffee Body Scrub",
        handle: "naked-raw-coffee-body-scrub-with-coconut",
        benefits: [
          "Reduces Tan",
          "Removes Dead Skin",
          "Energizing Coffee Aroma"
        ],
        ingredients: "Coffee | Caffeine",
        note: "*Not Recommended for Highly sensitive skin"
      },
      "Body Lotion": {
        title: "10% Magnesium Body Lotion",
        handle: "10-magnesium-body-lotion",
        benefits: [
          "Eases muscle cramps",
          "Helps in muscle recovery",
          "Helps promote better sleep",
          "Soothing Vanilla-Orchid Scent"
        ],
        ingredients: "Magnesium | Cocoa Butter | Chamomile"
      }
    }

  },
  /* ======================================================
       Tanning
    ====================================================== */
  "Tanning": {

    Him: {
      "Body Wash": {
        title: "Guava Tini Body Wash",
        handle: "guava-tini-de-tan-body-wash",
        benefits: [
          "Reduces Dark Spots",
          "Evens Skin Tone",
          "Brightens Skin",
          "Juicy Guava Fragrance"
        ],
        ingredients: "Glycolic Acid | Niacinamide | Glutathione"
      },
      "Body Scrub": {
        title: "Coffee Body Scrub",
        handle: "naked-raw-coffee-body-scrub-with-coconut",
        benefits: [
          "Reduces Tan",
          "Removes Dead Skin",
          "Energizing Coffee Aroma"
        ],
        ingredients: "Coffee | Caffeine"
      },
      "Body Lotion": {
        title: "Raspberry Body Lotion with SPF",
        handle: "brightening-raspberry-spf-50-pa-body-sunscreen-lotion",
        benefits: [
          "Reduces Tan",
          "Cools skin instantly",
          "Provides sun protection"
        ],
        ingredients: "Raspberry Extract | Niacinamide | Coffee Extract"
      }
    },

    Her: {
      "Body Wash": {
        title: "Guava Tini Body Wash",
        handle: "guava-tini-de-tan-body-wash",
        benefits: [
          "Reduces Dark Spots",
          "Evens Skin Tone",
          "Brightens Skin",
          "Juicy Guava Fragrance"
        ],
        ingredients: "Glycolic Acid | Niacinamide | Glutathione"
      },
      "Body Scrub": {
        title: "Coffee Body Scrub",
        handle: "naked-raw-coffee-body-scrub-with-coconut",
        benefits: [
          "Reduces Tan",
          "Removes Dead Skin",
          "Energizing Coffee Aroma"
        ],
        ingredients: "Coffee | Caffeine"
      },
      "Body Lotion": {
        title: "Raspberry Body Lotion with SPF",
        handle: "brightening-raspberry-spf-50-pa-body-sunscreen-lotion",
        benefits: [
          "Reduces Tan",
          "Cools skin instantly",
          "Provides sun protection"
        ],
        ingredients: "Raspberry Extract | Niacinamide | Coffee Extract"
      }
    },

    Unisex: {
      "Body Wash": {
        title: "Guava Tini Body Wash",
        handle: "guava-tini-de-tan-body-wash",
        benefits: [
          "Reduces Dark Spots",
          "Evens Skin Tone",
          "Brightens Skin",
          "Juicy Guava Fragrance"
        ],
        ingredients: "Glycolic Acid | Niacinamide | Glutathione"
      },
      "Body Scrub": {
        title: "Coffee Body Scrub",
        handle: "naked-raw-coffee-body-scrub-with-coconut",
        benefits: [
          "Reduces Tan",
          "Removes Dead Skin",
          "Energizing Coffee Aroma"
        ],
        ingredients: "Coffee | Caffeine"
      },
      "Body Lotion": {
        title: "Raspberry Body Lotion with SPF",
        handle: "brightening-raspberry-spf-50-pa-body-sunscreen-lotion",
        benefits: [
          "Reduces Tan",
          "Cools skin instantly",
          "Provides sun protection"
        ],
        ingredients: "Raspberry Extract | Niacinamide | Coffee Extract"
      }
    }
  }



};


/* ======================================================
   DOM
====================================================== */
const content = document.getElementById("quizContent");
const footer = document.getElementById("quizFooter");
const progress = document.getElementById("progressBar");
const backBtn = document.getElementById("backBtn");

/* ======================================================
   INIT
====================================================== */
loadState();
render();
// clevertap event for quiz start - only on first step to avoid duplicates on back navigation
clevertap.event.push("skinification_started", {
  page: window.location.pathname,
  source: "skinification_quiz",
  device: "web"
})

/* ======================================================
   MAIN RENDER
====================================================== */
function render() {
  ;

  saveState();

  progress.style.width =
    ((state.step + (state.step >= steps.length ? 1 : 0)) /
      (steps.length + 1)) *
    100 +
    "%";

  if (state.step < steps.length) {

    renderStep();
  } else {
    renderSolution();
  }
}


// Clevertap event tracking helper
function pushCTEvent(eventName, payload) {
  if (
    window.clevertap &&
    clevertap.event &&
    typeof clevertap.event.push === "function"
  ) {
    clevertap.event.push(eventName, payload);
  }
}


/* ======================================================
   QUIZ STEP RENDER
====================================================== */

function renderStep() {


  const step = steps[state.step];
  var temp_step = state.step + 1;
  //  CleverTap – Question Viewed
  pushCTEvent("skinification_question_viewed", {
    step_index: temp_step,
    step_key: step.key,
    step_title: step.title,
    page: window.location.pathname
  });

  const icons = optionIconMap[step.key] || {};

  content.innerHTML = `
    <div class="step">
      <h2>${step.title}</h2>
      <p>${step.subtitle}</p>

      <div class="options options-${step.key}-row">
        ${step.options.map(option => `
          <div class="option option-${step.key}-item ${state[step.key] === option ? 'active' : ''}"
               onclick="selectOption('${step.key}', '${option}')">

            <span class="option-icon">
              ${icons[option] || ""}
            </span>

            <span class="option-text">
              ${option}
            </span>

          </div>
        `).join("")}
      </div>
    </div>
  `;

  footer.innerHTML = "";


}


/* ======================================================
   SELECT OPTION
====================================================== */
function selectOption(key, value) {

  pushCTEvent("skinification_option_selected", {
    step_key: key,
    selected_value: value,
    previous_value: state[key] || null,
    page: window.location.pathname
  });

  // state[key] = value;
  // Normalize gender value for internal mapping
  if (key === "gender" && value === "Prefer not to say") {
    state[key] = "Unisex";
  } else {
    state[key] = value;
  }

  if (key === "vibe") {
    state.solutionTabIndex = 0; // reset tabs
    state.selectedProducts = {}; // reset selections
  }

  state.step++;
  saveState();
  render();
}


/* ======================================================
   BACK BUTTON
====================================================== */
backBtn.onclick = () => {
  //  CleverTap – Back Button Clicked
  pushCTEvent("skinification_back_clicked", {
    from_step: state.step,
    to_step: state.step - 1,
    page: window.location.pathname
  });

  if (state.step > 0) {
    state.step--;
  } else if (state.solutionTabIndex > 0) {
    state.solutionTabIndex--;
  }
  saveState();
  render();
};

/* ======================================================
   ROUTINE RESOLVER (SAFE)
====================================================== */
function getRoutine() {
  if (!state.concern) return null;

  const c = routineMapping[state.concern];
  if (!c) return null;

  return (
    c[state.gender] ||
    c.Unisex ||
    c.Him ||
    Object.values(c)[0]
  );
}

/* ======================================================
   SOLUTION RENDER
====================================================== */

async function renderSolution() {

  // CleverTap – Solution Viewed
  pushCTEvent("skinification_solution_viewed", {
    gender: state.gender,
    skin_type: state.skinType,
    concern: state.concern,
    vibe: state.vibe,
    page: window.location.pathname
  });

  const routine = getRoutine();
  if (!routine) {
    content.innerHTML = "<p class='no-routine'>No routine found</p>";
    return;
  }

  // Ensure selectedProducts exists
  if (!state.selectedProducts || typeof state.selectedProducts !== "object") {
    state.selectedProducts = {};
  }

  const tabs = Object.keys(routine);
  const activeTabName = tabs[state.solutionTabIndex] || tabs[0];
  const data = routine[activeTabName];

  // Guard against broken mapping
  if (!data || !data.handle) {
    console.error("Missing product data:", activeTabName, data);
    return;
  }

  // Auto-check product on first visit
  if (!(data.handle in state.selectedProducts)) {
    state.selectedProducts[data.handle] = true;
  }

  const product = await fetch(`/products/${data.handle}.js`).then(r => r.json());


  content.innerHTML = `
    <div class="solution">
     <div class="solution-inner-text">
      <h2>Your Personalized Routine for</h2>
      <h3>${state.skinType} + ${state.concern}</h3>
      <p class="vibe">${vibeCopy[state.vibe]}</p>
      <p class="powered" >Powered by science-backed ingredients</p>
      </div>

      <div class="tabs">
  ${tabs.map((t, i) => `
    <button
      class="${i === state.solutionTabIndex ? "active" : ""}"
      onclick="setSolutionTab(${i})">
      ${t}
    </button>
  `).join("")}
</div>

      <div class="benefits-box">
        <strong>Benefits</strong>
        <ul>${data.benefits.map(b => `<li>✓ ${b}</li>`).join("")}</ul>
        <div class="ingredients">
          <strong>Key Ingredients:<br></strong> ${data.ingredients}
        </div>
      </div>

      <div   onclick="toggleProductCard('${data.handle}', event)" class="product-card ${!product.available ? "out-of-stock" : ""} ${state.selectedProducts[data.handle] ? "selected" : ""}">
        <div class="product-image">
        <img src="${product.images[0]}" />
        </div>
        <div class="product-info">
          <label>
            <input type="checkbox"
              ${state.selectedProducts[data.handle] ? "checked" : ""}
              onchange="toggleProduct('${data.handle}')">
            ${product.title}
          </label>
          <div class="price">₹${product.price / 100}</div>
         
        </div>
      </div>
      
       ${data.note ? `<div class="note-container"><p class="note">${data.note}</p></div>` : ""}
      
    </div>
  `;

  renderSolutionFooter(tabs);
}

function toggleProductCard(handle, e) {
  // Prevent double toggle if checkbox itself clicked
  if (e.target.tagName === "INPUT") return;

  state.selectedProducts[handle] = !state.selectedProducts[handle];
  saveState();
  renderSolution();
}


function setSolutionTab(index) {
  // CleverTap – Tab Clicked
  var temp_step = index + 1;
  pushCTEvent("skinification_tab_clicked", {
    tab_name: Object.keys(getRoutine())[index],
    tab_index: temp_step,
    concern: state.concern,
    page: window.location.pathname
  });

  state.solutionTabIndex = index;
  saveState();
  renderSolution();
}

function renderFinalLoader() {
  footer.innerHTML = `
    <div class="final-loader">
      <div class="spinner"></div>
      <p>Building your personalized routine…</p>
    </div>
  `;
}


/* ======================================================
   SOLUTION TAB NEXT
====================================================== */
function nextSolutionTab() {
  // CleverTap – Next Tab Clicked
  pushCTEvent("skinification_next_clicked", {
    from_tab: Object.keys(getRoutine())[state.solutionTabIndex],
    to_tab: Object.keys(getRoutine())[state.solutionTabIndex + 1],
    concern: state.concern
  });


  const routine = getRoutine();
  if (!routine) return;

  const tabs = Object.keys(routine);

  if (state.solutionTabIndex < tabs.length - 1) {
    state.solutionTabIndex++;
    saveState();
    renderSolution();
  }
}


function setTabByIndex(index) {
  state.solutionTabIndex = index;
  saveState();
  renderSolution();
}



function toggleProduct(handle) {
  // CleverTap – Product Toggled
  pushCTEvent("skinification_product_toggled", {
    product_handle: handle,
    action: state.selectedProducts[handle] ? "checked" : "unchecked",
    tab_name: Object.keys(getRoutine())[state.solutionTabIndex],
    concern: state.concern
  });

  state.selectedProducts[handle] = !state.selectedProducts[handle];
  saveState();
  renderSolution();
}

async function addSelectedToCart() {

  // Clevertap – Add to Cart Clicked
  pushCTEvent("skinification_add_to_cart_clicked", {
    selected_count: getSelectedHandles().length,
    concern: state.concern,
    vibe: state.vibe,
    page: window.location.pathname
  });

  const isApp = window.ReactNativeWebView || window.appbrew || window.appbrewSDK;

  const variantIds = await getSelectedVariantIds();

  //  Guard
  if (variantIds.length === 0) {
    showCartWarning("Add at least one product to continue");
    return;
  }

  const addBtn = document.querySelector(".summary-bar button");

  // Loader UI
  if (addBtn) {
    addBtn.disabled = true;
    addBtn.dataset.originalHtml = addBtn.innerHTML;
    addBtn.innerHTML = `<span class="loading-spinner"></span> Adding…`;
  }

  try {

    /* =====================================================
       APP FLOW (Appbrew)
    ===================================================== */
    if (isApp && window.appbrewSDK?.addToCart) {
      for (let id of variantIds) {
        await window.appbrewSDK.addToCart(
          null,
          `gid://shopify/ProductVariant/${id}`,
          1
        );
      }
      appBrewgotoCart();
      return;
    }

    /* =====================================================
       WEB FLOW (DAWN)
    ===================================================== */

    const cart =
      document.querySelector("cart-drawer") ||
      document.querySelector("cart-notification");

    const items = variantIds.map(id => ({
      id,
      quantity: 1
    }));

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({
        items,
        ...(cart && {
          sections: cart.getSectionsToRender().map(s => s.id),
          sections_url: window.location.pathname
        })
      })
    });

    const data = await response.json();

    // 🔥 THIS IS THE KEY FIX
    if (cart && typeof cart.renderContents === "function") {
      cart.renderContents(data);
      cart.classList.remove("is-empty");

      // Clevertap – Add to Cart Success
      pushCTEvent("skinification_add_to_cart_success", {
        product_handles: getSelectedHandles(),
        total_items: getSelectedHandles().length,
        cart_type: "drawer"
      });

    } else {
      // fallback
      window.location.href = "/cart";
    }

  } catch (err) {
    console.error("Skinification add to cart failed:", err);
    showCartWarning("Something went wrong. Please try again.");

    // Clevertap – Add to Cart Failed
    pushCTEvent("skinification_add_to_cart_failed", {
      error_message: err.message,
      product_handles: getSelectedHandles(),
      total_items: getSelectedHandles().length
    });

  } finally {
    // Restore button
    if (addBtn) {
      addBtn.disabled = false;
      addBtn.innerHTML = addBtn.dataset.originalHtml;
    }
  }
}


function getSelectedHandles() {
  return Object.keys(state.selectedProducts || {})
    .filter(h => state.selectedProducts[h]);
}

async function getSelectedVariantIds() {
  const handles = Object.keys(state.selectedProducts || {})
    .filter(h => state.selectedProducts[h]);

  if (handles.length === 0) return [];

  const products = await Promise.all(
    handles.map(h => fetch(`/products/${h}.js`).then(r => r.json()))
  );

  return products.map(p => p.variants[0].id);
}




// Helper to count selected products for enabling/disabling Add to Cart button
function getSelectedCount() {
  return Object.values(state.selectedProducts || {}).filter(Boolean).length;
}




function renderSolutionFooter(tabs) {
    renderFinalLoader();
    setTimeout(() => {
      renderBottomSummary(tabs);
    }, 300);
}


// ======================================================
// BOTTOM SUMMARY RENDER
// ======================================================

async function renderBottomSummary(tabs) {

  console.log('renderBottomSummary')
  // Clevertap – Summary Viewed
  pushCTEvent("skinification_summary_viewed", {
    total_products_selected: getSelectedHandles().length,
    concern: state.concern,
    vibe: state.vibe
  });

  const routine = getRoutine();
  let total = 0;
  let itemsHTML = "";
  const SOLUTION_TABS = ["Body Wash", "Body Scrub", "Body Lotion"];

  for (let i = 0; i < SOLUTION_TABS.length; i++) {
    const tab = SOLUTION_TABS[i];
    const data = routine[tab];
    if (!data) continue;

    const handle = data.handle;
    const isSelected = state.selectedProducts[handle];

    if (isSelected) {
      const p = await fetch(`/products/${handle}.js`).then(r => r.json());
      total += p.price / 100;

      itemsHTML += `
        <div class="summary-item selected"
             onclick="goToSolutionTab(${i})">
          <img src="${p.images[0]}" alt="${p.title}" />
          <button class="remove-btn"
            onclick="event.stopPropagation(); removeProduct('${handle}')">
            ×
          </button>
        </div>
      `;
    } else {
      itemsHTML += `
        <div class="summary-item placeholder"
             onclick="goToSolutionTab(${i})">
          <span>ADD</span>
          <small>Step ${i + 1}</small>
        </div>
      `;
    }
  }

  const isLastTab = state.solutionTabIndex === tabs.length - 1;

  footer.innerHTML = `
    <div class="summary-items">
      ${itemsHTML}
    </div>

    <div class="summary-bar">
      <span>Total: ₹${total.toFixed(2)}</span>
      ${!isLastTab ? `<button class="primary-btn nextSolutionTab" onclick="nextSolutionTab()">Next</button>` : `<button class="primary-btn" onclick="addSelectedToCart()" ${getSelectedCount() === 0 ? "disabled" : ""}>Add to Cart</button>`}


${getSelectedCount() === 0
      ? `<p class="cart-warning">Add at least one product to continue</p>`
      : ""}

    </div>
  `;
}


function goToSolutionTab(tabIndex) {
  // clevertap event for tab click from summary
  pushCTEvent("skinification_product_readd_clicked", {
    tab_name: Object.keys(getRoutine())[tabIndex],
    concern: state.concern
  });


  state.solutionTabIndex = tabIndex;
  saveState();
  renderSolution();
}

// REMOVE PRODUCT FROM SUMMARY
function removeProduct(handle) {
  state.selectedProducts[handle] = false;
  saveState();
  renderSolution();
}

const SOLUTION_TABS = ["Body Wash", "Body Scrub", "Body Lotion"];
function getTabByHandle(handle) {
  const routine = getRoutine();
  if (!routine) return null;

  for (const tab in routine) {
    if (routine[tab].handle === handle) {
      return tab;
    }
  }
  return null;
}


/* =========================================
   OPTION HOVER ACTIVE LOGIC
========================================= */

document.addEventListener("mouseover", function (e) {
  const option = e.target.closest("#quizContent .step .option");
  if (!option) return;

  const container = option.closest(".options");
  if (!container) return;

  // Remove active from all
  container.querySelectorAll(".option").forEach(opt => {
    opt.classList.remove("active");
  });
});


document.addEventListener("mouseout", function (e) {
  const option = e.target.closest("#quizContent .step .option");
  if (!option) return;

  const step = steps[state.step];
  if (!step) return;

  const selectedValue = state[step.key];
  if (!selectedValue) return;

  const container = option.closest(".options");
  if (!container) return;

  const options = container.querySelectorAll(".option");

  options.forEach(opt => {
    if (opt.innerText.trim() === selectedValue.trim()) {
      opt.classList.add("active");
    }
  });
});


